(function() {
  var StepFunctions, StepTransition,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  StepFunctions = App.loadClass('grower::classes/placement/StepFunctions');

  StepTransition = App.loadClass('grower::classes/placement/StepTransition');

  exports.SppHandler = (function(superClass) {
    extend(SppHandler, superClass);

    function SppHandler() {
      this.handleError = bind(this.handleError, this);
      this.disableButton = bind(this.disableButton, this);
      this.enableButton = bind(this.enableButton, this);
      this.showPalletTags = bind(this.showPalletTags, this);
      this.generatePalletTags = bind(this.generatePalletTags, this);
      this.showPsr = bind(this.showPsr, this);
      this.actionPdf = bind(this.actionPdf, this);
      this.customProductSubscription = bind(this.customProductSubscription, this);
      this.customPopulationAdjustment = bind(this.customPopulationAdjustment, this);
      this.customPlanterSubscription = bind(this.customPlanterSubscription, this);
      SppHandler.__super__.constructor.call(this);
      this.useMessageWriter = true;
      this.inputChanged = false;
      this.stepFunctions = new StepFunctions();
      this.customStepFunctions = {};
      this.customButton = null;
      this.customButtonFn = function() {};
    }

    SppHandler.prototype.init = function() {
      this.loadLayoutPostOptions = {
        id: this.sppID
      };
      if (this.resultID != null) {
        this.loadLayoutPostOptions.result_id = this.resultID;
      }
      this.layoutUrl = 'backend/grower/placement/spp/load-layout';
      this.createDialog();
      this.openDialog();
      return this.displayLoadingMessage('Please wait...<br>' + 'Loading field data, product details, and personalized crop management questions...');
    };

    SppHandler.prototype.afterLoadLayout = function(selector, response) {
      var data, ref, ref1, ref2, stepNum;
      if ((response != null ? (ref = response.status) != null ? ref.type : void 0 : void 0) !== 'success') {
        return;
      }
      data = response.data;
      this.importSteps();
      this.companyID = data.company_id;
      this.cropID = data.crops_id;
      this.cropName = data.crop_name;
      this.year = +data.year;
      this.resultID = data.result_id;
      this.finished = data.finished;
      this.popWeightings = data.population_weightings;
      this.rowSpacings = data.row_spacings;
      this.operators_id = (ref1 = data.operators_id) != null ? ref1 : null;
      this.operator_name = (ref2 = data.operator_name) != null ? ref2 : null;
      this.enable_rx_plans = data.enable_rx_plans;
      this.makes_recommendations = data.makes_recommendations;
      this.calculates_populations = data.calculates_populations;
      this.numVisibleResults = data.number_of_visible_hybrid_results;
      stepNum = data.step_num;
      if (stepNum === this.taffyObjects.steps().count()) {
        this.currentFieldID = data.fields_id;
      }
      this.parent.afterSurveyLoaded(this);
      return this.goToStep(stepNum);
    };

    SppHandler.prototype.goToStep = function(stepNum, fromNav) {
      if (fromNav == null) {
        fromNav = false;
      }
      if (!this.curTransition) {
        return this.curTransition = new StepTransition(this.curStep || this, stepNum, fromNav);
      }
    };

    SppHandler.prototype.importSteps = function() {
      var valid_step_functions;
      valid_step_functions = ['afterEnter', 'beforeLeave', 'skipConditions'];
      this.subHandlers = [];
      this.taffyObjects.steps().each((function(_this) {
        return function(step) {
          var fn, handler_name, k, key, ref;
          key = "step_" + step.step_order;
          handler_name = step.widget_name.replace(/_/g, '') + 'Handler';
          _this.subHandlers[key] = {
            "class": "grower::handlers/placement/widgets/" + handler_name,
            attrs: {
              id: step.id,
              num: step.step_order
            }
          };
          if (_this.customStepFunctions[key] != null) {
            ref = _this.customStepFunctions[key];
            for (k in ref) {
              fn = ref[k];
              if (indexOf.call(valid_step_functions, k) >= 0) {
                step[k] = fn;
              }
            }
          }
          return step.parent = _this;
        };
      })(this));
      return this.has_multiple_steps = this.taffyObjects.steps({
        widget_name: {
          '!is': 'Seed_Options'
        }
      }).count() > 1;
    };

    SppHandler.prototype.getHighestVisitedStep = function() {
      var num;
      num = 0;
      this.taffyObjects.steps().each((function(_this) {
        return function(step) {
          if (step.visited() && step.step_order > num) {
            return num = step.step_order;
          }
        };
      })(this));
      return num;
    };

    SppHandler.prototype.getFieldAspectByName = function(field_id, aspect_name) {
      var aspect;
      aspect = this.taffyObjects.fieldsAspects({
        fields_id: field_id,
        aspect_name: aspect_name
      }).first();
      return aspect;
    };

    SppHandler.prototype.finish = function(callback) {
      var postOptions;
      if (callback == null) {
        callback = function() {};
      }
      this.finished = true;
      $('#reset_survey_button').addClass('btn-primary');
      postOptions = {
        id: this.sppID,
        result_id: this.resultID
      };
      return $.post('backend/grower/placement/spp/finish-survey', postOptions, (function(_this) {
        return function(response) {
          return callback(response);
        };
      })(this));
    };

    SppHandler.prototype.destroy = function() {
      $('.spp-step-list').hide();
      return SppHandler.__super__.destroy.call(this);
    };

    SppHandler.prototype.customPlantingPlan = function(field_id, plan, notes_obj) {};

    SppHandler.prototype.customPlanterSubscription = function(event, planter_id) {
      return typeof this._customPlanterSubscription === "function" ? this._customPlanterSubscription(event, planter_id) : void 0;
    };

    SppHandler.prototype.customPopulationAdjustment = function(event, population) {
      var ref;
      return (ref = typeof this._customPopulationAdjustment === "function" ? this._customPopulationAdjustment(event, population) : void 0) != null ? ref : null;
    };

    SppHandler.prototype.customProductSubscription = function(stage, product_id) {
      return typeof this._customProductSubscription === "function" ? this._customProductSubscription(stage, product_id) : void 0;
    };

    SppHandler.prototype.actionPdf = function(layer_ids, long_pdf, disable_extra_button) {
      var button_id, params;
      if (long_pdf == null) {
        long_pdf = false;
      }
      if (disable_extra_button == null) {
        disable_extra_button = false;
      }
      button_id = '#pdf_button';
      this.disableButton(button_id, !long_pdf);
      if (disable_extra_button) {
        this.disableButton(disable_extra_button, long_pdf);
      }
      params = {
        id: this.sppID,
        result_id: this.resultID,
        layer_ids: layer_ids,
        send_email: true,
        long_pdf: long_pdf
      };
      return $.post('backend/grower/placement/spp/generate-psr', params, (function(_this) {
        return function(response) {
          var ref;
          if ((response != null ? (ref = response.status) != null ? ref.type : void 0 : void 0) === 'success') {
            _this.showPsr(response, button_id);
          } else {
            _this.handleError(response, button_id, 'placement report');
          }
          if (disable_extra_button) {
            return _this.enableButton(disable_extra_button);
          }
        };
      })(this));
    };

    SppHandler.prototype.showPsr = function(response, button_id) {
      var e, params;
      try {
        params = $.param({
          file: response.data.file,
          file_name: response.data.file_name
        });
        window.open("backend/grower/placement/report/show-psr?" + params);
        return this.enableButton(button_id);
      } catch (error) {
        e = error;
        this.enableButton(button_id);
        throw e;
      }
    };

    SppHandler.prototype.generatePalletTags = function(layer_ids, button_id) {
      var params;
      this.disableButton(button_id);
      params = {
        id: this.sppID,
        layer_ids: layer_ids
      };
      return $.post('backend/grower/placement/pallet-tags/create', params).done((function(_this) {
        return function(response) {
          if (response.file && response.file_name) {
            return _this.showPalletTags(response, button_id);
          } else {
            return _this.handleError(response, button_id, 'pallet tags');
          }
        };
      })(this)).fail((function(_this) {
        return function(response) {
          return _this.handleError(response, button_id, 'pallet tags');
        };
      })(this));
    };

    SppHandler.prototype.showPalletTags = function(response, button_id) {
      var e, paramStr;
      try {
        paramStr = $.param({
          file: response.file,
          file_name: response.file_name
        });
        window.open("backend/grower/placement/pallet-tags/get?" + paramStr);
        return this.enableButton(button_id);
      } catch (error) {
        e = error;
        this.enableButton(button_id);
        throw e;
      }
    };

    SppHandler.prototype.enableButton = function(button_id) {
      return $(button_id).button('reset');
    };

    SppHandler.prototype.disableButton = function(button_id, is_processing) {
      if (is_processing == null) {
        is_processing = true;
      }
      if (is_processing) {
        $(button_id).button('loading');
      }
      if (!is_processing) {
        return $(button_id).prop("disabled", true);
      }
    };

    SppHandler.prototype.handleError = function(response, button_id, thing) {
      var default_msg, ref, ref1, ref2, ref3, ref4, sub;
      sub = 'grower::handlers/placement/widgets/SeedOptionsHandler';
      default_msg = "Failed to generate " + thing + ". Please contact MyFarms Support for assistance.";
      if ((ref = this.activeSubHandlers[sub]) != null) {
        ref.msg.message_writer((ref1 = response != null ? (ref2 = response.status) != null ? ref2.type : void 0 : void 0) != null ? ref1 : 'error', (ref3 = response != null ? (ref4 = response.status) != null ? ref4.msg : void 0 : void 0) != null ? ref3 : default_msg, true);
      }
      return this.enableButton(button_id);
    };

    return SppHandler;

  })(FullPageHandler);

}).call(this);
